let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("edLnO")).then(() => parcelRequire('10LH3'));